'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(ModalSize2) {
  ModalSize2["DEFAULT"] = "small";
  ModalSize2["LARGE"] = "large";
  ModalSize2["MOBILE_OVERLAY"] = "mobile-overlay";
  ModalSize2["BORDERLESS"] = "borderless";
})(exports.ModalSize || (exports.ModalSize = {}));
